/** @format */

import { useFlags } from "launchdarkly-react-client-sdk";

export const useFeatureFlag = (flagKey: string): boolean => {
	const flags = useFlags();
	return Boolean(flags[flagKey]);
};
